<!--
 * @Author: zhaoyang
 * @Date: 2024-02-25 15:23:33
 * @Last Modified by: xiaodongyu
 * @Last Modified time: 2024-03-06 16:07:25
-->

<template>
    <div class="container list">
        <div class="title">
            募集中のフアンド
        </div>
        <div class="box">
            <div class="box-title">
                匿名組合契約型
            </div>
            <div class="title1">
                インドネシア・マイクロファイナンス第1号
            </div>
            <div class="title2">
                目標利回り：７％／年
            </div>
            <div class="title2">
                運用期間：１８０日
            </div>
            <div class="title2">
                ファンド名：インドネシア・マイクロファイナンス第1号（匿名組合契約型）
            </div>
            <img
                src="./img/arrow.svg"
                alt=""
                class="arrow"
                @click="onGo"
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductList',

    methods: {
        onGo() {
            this.$router.push('/product/1');
        }
    }
};
</script>

<style lang="scss" scoped>
.list {
    .title {
        color: #32302f;
        padding-top: 0.4rem;
        font-family: Noto serif JP;
        font-size: 0.4rem;
        font-weight: 700;
        line-height: 0.52rem;
    }

    .box {
        position: relative;
        margin-top: 0.4rem;
        box-sizing: border-box;
        border-radius: 0.16rem;
        padding: 0.4rem 0.6rem;
        background-image: url("./img/bg-s.png");
        background-size: 100% 100%;

        .box-title {
            font-family: Noto Sans JP;
            font-size: 0.14rem;
            font-weight: 400;
            line-height: 0.22rem;
            color: #cacaca;
        }

        .title1 {
            margin-top: 0.16rem;
            margin-bottom: 0.16rem;
            font-family: Noto serif JP;
            font-size: 0.32rem;
            font-weight: 700;
            line-height: 0.42rem;
            color: #fff;
        }

        .title2 {
            font-family: Noto Sans JP;
            font-size: 0.14rem;
            font-weight: 400;
            line-height: 0.22rem;
            color: #fff;
        }

        .arrow {
            margin-top: 0.36rem;
            width: 0.48rem;
            height: 0.48rem;
        }
    }
}
</style>
